/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UtenteAddPermissionDTO
 */
export interface UtenteAddPermissionDTO {
    /**
     * 
     * @type {string}
     * @memberof UtenteAddPermissionDTO
     */
    permissionId?: string | null;
}

/**
 * Check if a given object implements the UtenteAddPermissionDTO interface.
 */
export function instanceOfUtenteAddPermissionDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UtenteAddPermissionDTOFromJSON(json: any): UtenteAddPermissionDTO {
    return UtenteAddPermissionDTOFromJSONTyped(json, false);
}

export function UtenteAddPermissionDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UtenteAddPermissionDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'permissionId': !exists(json, 'permissionId') ? undefined : json['permissionId'],
    };
}

export function UtenteAddPermissionDTOToJSON(value?: UtenteAddPermissionDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'permissionId': value.permissionId,
    };
}

